// The placeholder icon in the header componenet, next the 'nom' and 'prénom'
export const profileLogoSvg = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9579 19.8C9.69474 20.2632 8.52632 20.8947 7.45263 21.6947C6.67368 20.8316 6.05263 19.8316 5.58947 18.6947C5.12632 17.5579 4.89474 16.3263 4.89474 15C4.89474 12.2 5.87916 9.81558 7.848 7.84674C9.816 5.87874 12.2 4.89474 15 4.89474C17.8 4.89474 20.1844 5.87874 22.1533 7.84674C24.1213 9.81558 25.1053 12.2 25.1053 15C25.1053 16.3263 24.8737 17.5579 24.4105 18.6947C23.9474 19.8316 23.3263 20.8316 22.5474 21.6947C21.4737 20.8947 20.3053 20.2632 19.0421 19.8C17.7789 19.3368 16.4316 19.1053 15 19.1053C13.5684 19.1053 12.2211 19.3368 10.9579 19.8ZM12.0796 14.7625C12.8686 15.5524 13.8421 15.9474 15 15.9474C16.1579 15.9474 17.1314 15.5524 17.9204 14.7625C18.7103 13.9735 19.1053 13 19.1053 11.8421C19.1053 10.6842 18.7103 9.71074 17.9204 8.92168C17.1314 8.13179 16.1579 7.73684 15 7.73684C13.8421 7.73684 12.8686 8.13179 12.0796 8.92168C11.2897 9.71074 10.8947 10.6842 10.8947 11.8421C10.8947 13 11.2897 13.9735 12.0796 14.7625ZM10.3112 26.0526C11.7739 26.6842 13.3368 27 15 27C16.6632 27 18.2265 26.6842 19.6901 26.0526C21.1528 25.4211 22.4211 24.5684 23.4947 23.4947C24.5684 22.4211 25.4211 21.1524 26.0526 19.6888C26.6842 18.2261 27 16.6632 27 15C27 13.3368 26.6842 11.7735 26.0526 10.3099C25.4211 8.84716 24.5684 7.57895 23.4947 6.50526C22.4211 5.43158 21.1528 4.57895 19.6901 3.94737C18.2265 3.31579 16.6632 3 15 3C13.3368 3 11.7739 3.31579 10.3112 3.94737C8.84758 4.57895 7.57895 5.43158 6.50526 6.50526C5.43158 7.57895 4.57895 8.84716 3.94737 10.3099C3.31579 11.7735 3 13.3368 3 15C3 16.6632 3.31579 18.2261 3.94737 19.6888C4.57895 21.1524 5.43158 22.4211 6.50526 23.4947C7.57895 24.5684 8.84758 25.4211 10.3112 26.0526ZM18.3006 24.552C17.2371 24.9208 16.1368 25.1053 15 25.1053C13.8632 25.1053 12.7629 24.9208 11.6994 24.552C10.6366 24.184 9.69474 23.6737 8.87368 23.0211C9.69474 22.3684 10.6265 21.8686 11.6691 21.5217C12.7107 21.1739 13.8211 21 15 21C16.1789 21 17.2893 21.1789 18.3309 21.5368C19.3735 21.8947 20.3053 22.3895 21.1263 23.0211C20.3053 23.6737 19.3634 24.184 18.3006 24.552ZM16.5789 13.4211C16.1579 13.8421 15.6316 14.0526 15 14.0526C14.3684 14.0526 13.8421 13.8421 13.4211 13.4211C13 13 12.7895 12.4737 12.7895 11.8421C12.7895 11.2105 13 10.6842 13.4211 10.2632C13.8421 9.8421 14.3684 9.63158 15 9.63158C15.6316 9.63158 16.1579 9.8421 16.5789 10.2632C17 10.6842 17.2105 11.2105 17.2105 11.8421C17.2105 12.4737 17 13 16.5789 13.4211Z"
      fill="#003E5C"
    />
  </svg>
);

export const leftArrowIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 11L10 16L11.062 14.938L6.875 10.75H16V9.25H6.875L11.062 5.062L10 4L4 10L5 11Z"
      fill="#003E5C"
    />
  </svg>
);

export const noDayAvailableIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 9.5V11.5H17.5V9.5H3.5Z"
      fill="#E0DED8"
    />
  </svg>
);

// * Buttons

// pencil icon
export const pencilIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.38524 15.6775H4.28124V14.5945L11.8232 7.0525L12.3642 7.6155L12.9062 8.1565L5.38524 15.6775ZM12.7182 4.2195L15.7182 7.2395L16.6562 6.3025C16.9202 6.0525 17.0522 5.7365 17.0522 5.3545C17.0522 4.9725 16.9272 4.6495 16.6772 4.3855L15.7392 3.4485C15.4339 3.1425 15.0626 2.9895 14.6252 2.9895C14.1872 2.9895 13.8086 3.1425 13.4892 3.4485L12.7182 4.2195ZM5.94824 17.0105L14.8022 8.1565L11.8022 5.1565L2.94824 14.0105V17.0105H5.94824Z"
      fill="#003E5C"
    />
  </svg>
);

// send icon
export const sendIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9998 10.25L4 4.25V16.25L17.9998 10.25ZM14.8662 10.25L5.22092 14.3879V11.3259L7.64275 10.7358C8.1516 10.6118 8.1516 9.88819 7.64275 9.76421L5.22092 9.17414V6.11207L14.8662 10.25Z"
      fill="white"
    />
  </svg>
);

// download icon
export const downloadIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.025 17.0625C3.375 17.4125 3.8 17.5875 4.3 17.5875H15.7C16.2 17.5875 16.625 17.4125 16.975 17.0625C17.325 16.7125 17.5 16.2875 17.5 15.7875V13.0875H16V15.7875C16 15.8541 15.9667 15.9208 15.9 15.9875C15.8333 16.0541 15.7667 16.0875 15.7 16.0875H4.3C4.23333 16.0875 4.16667 16.0541 4.1 15.9875C4.03333 15.9208 4 15.8541 4 15.7875V13.0875H2.5V15.7875C2.5 16.2875 2.675 16.7125 3.025 17.0625ZM5.725 9.43748L10 13.7125L14.275 9.43748L13.225 8.33748L10.75 10.8125V2.41248H9.25V10.8125L6.775 8.33748L5.725 9.43748Z"
      fill="#00AEC3"
    />
  </svg>
);
export const downloadIconWhite = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.025 17.0625C3.375 17.4125 3.8 17.5875 4.3 17.5875H15.7C16.2 17.5875 16.625 17.4125 16.975 17.0625C17.325 16.7125 17.5 16.2875 17.5 15.7875V13.0875H16V15.7875C16 15.8541 15.9667 15.9208 15.9 15.9875C15.8333 16.0541 15.7667 16.0875 15.7 16.0875H4.3C4.23333 16.0875 4.16667 16.0541 4.1 15.9875C4.03333 15.9208 4 15.8541 4 15.7875V13.0875H2.5V15.7875C2.5 16.2875 2.675 16.7125 3.025 17.0625ZM5.725 9.43748L10 13.7125L14.275 9.43748L13.225 8.33748L10.75 10.8125V2.41248H9.25V10.8125L6.775 8.33748L5.725 9.43748Z"
      fill="#fff"
    />
  </svg>
);

// 'Retour' button

export const greyleftArrowIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 11L10.5 16L11.562 14.938L7.375 10.75H16.5V9.25H7.375L11.562 5.062L10.5 4L4.5 10L5.5 11Z"
      fill="#58585A"
    />
  </svg>
);

//* Misc

// check badge icon

export const checkBadgeIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="15.5" fill="white" stroke="#003E5C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2496 21.3501L17.5496 25.6501L27.7746 15.4251L26.7246 14.3501L17.5496 23.5251L13.2746 19.2501L12.2246 20.3251L13.2246 21.3251V21.3501H13.2496Z"
      fill="#003E5C"
    />
  </svg>
);

// close icon

export const closeIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1786 20L10.5893 27.5893L12.4107 29.4107L20 21.8214L27.5893 29.4107L29.4107 27.5893L21.8214 20L29.4107 12.4107L27.5893 10.5893L20 18.1786L12.4107 10.5893L10.5893 12.4107L18.1786 20Z"
      fill="#AFAFAF"
    />
  </svg>
);

// icon for buttoun continuer ma modification

export const continuerModificationIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.416 10L6.70801 2.29201L5.58301 3.41701L12.187 10L5.58301 16.583L6.70801 17.708L14.416 10Z"
      fill="white"
    />
  </svg>
);
